import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-bottom: 0.8em;
`;



// WEBPACK FOOTER //
// ./src/components/FormField/styles.ts